module.exports = __webpack_public_path__ + "static/media/leinen.0b4d0e73.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/leinen.jpeg
// module id = 281
// module chunks = 0